<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center text-center>
      <v-flex xs12 sm8 md4>
        <v-img
          style="width: 100%;display: block;margin-bottom: 10px;"
          :src="require('../assets/logo.png')"
        ></v-img>
        <h1
          style="color: rgba(0,0,0,0.2);text-shadow: 0 0 1.25px #474747;margin-bottom:10px;"
        >
          {{ $t("views.sharefiles.title") }}
        </h1>
        <v-card>
          <v-card-title>
            <h3 style="margin-bottom:10px;">
              {{ $t("views.sharefiles.share_files") }}
            </h3>
          </v-card-title>
          <v-card-text v-if="validToken">
            <v-form :disabled="loading" ref="form" v-model="valid">
              <no-autocomplete-textfield
                outlined
                v-model="email"
                :label="$t('views.sharefiles.email')"
                :rules="[$rules.required, $rules.email]"
                class="required"
              ></no-autocomplete-textfield>
              <vue-recaptcha
                v-on:expired="recaptchaValid = false"
                v-on:verify="recaptchaCallback($event)"
                :sitekey="settings.SiteKey"
              ></vue-recaptcha>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" text @click="cancel">
              {{ $t("globals.cancel") }}
            </v-btn>
            <v-btn
              :disabled="!valid || !recaptchaValid"
              :loading="loading"
              color="primary"
              @click="handleSubmit"
            >
              {{ $t("views.sharefiles.get_files") }}
            </v-btn>
          </v-card-actions>
          <error-handler :error="error" />
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import { mapGetters, mapActions } from "vuex";
import jwt from "jsonwebtoken";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import decode from "jsonwebtoken/decode";
import ErrorHandler from "../components/ErrorHandler.vue";
import { base64ToArrayBuffer } from "../utils/file.js";
import { saveAs } from "file-saver";
import ApiService from "@/services/api.service";
export default {
  name: "register",
  components: { VueRecaptcha, NoAutocompleteTextfield, ErrorHandler },
  data() {
    return {
      validToken: false,
      decoded: {
        email: null,
        file: null,
        guest: false,
        name: null
      },
      recaptchaValid: false,
      valid: false,
      email: "",
      error: null,
    };
  },
  watch: {},
  computed: {
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("common", { selectedPlan: "plan", settings: "settings" }),
    ...mapGetters("plansMembers", { planParameters: "planOptions" }),
    ...mapGetters("common", ["language"]),
  },
  async mounted() {
    try {
      console.log("mounted");
      var token = this.$route.params.token;
      var decoded = jwt.verify(token, this.settings.RegistrationTokenSecret);
      console.log(decoded);
      this.validToken = true;
      this.decoded.email = decoded.email;
      this.decoded.file = decoded.file;
      this.decoded.name = decoded.name;
      this.decoded.guest = decoded.guest === "True" ? true : false;
    } catch (err) {
      console.log("ERROR: ", err);
      this.error = {
        customMessage: "Token decoding error",
      };
      // this.error = err;
    }
  },
  methods: {
    ...mapActions("applicationUsers", [
      "getUserByEmail",
      "getSharedFiles",
    ]),
    ...mapActions("documentsService", ["downloadFileGuest"]),
    recaptchaCallback(event) {
      this.recaptchaValid = true;
    },
    async handleSubmit() {
      try {
        if (this.email !== this.decoded.email) {
          throw {
            customMessage: "Wrong User",
          }
        }
        this.loading = true;
        const res = (await this.downloadFileGuest({ ids: [this.decoded.file] })).data;
        ApiService.removeHeaders();
        const blob = this.$files.b64toBlob(res);
        saveAs(blob, this.decoded.name);
      } catch (e) {
        this.error = e;
      } finally {
        this.loading = false;
      }
    },
    cancel() {
      window.location = window.location.origin+"/";
    },
  },
};
</script>
